export const YoutubeLogoSVG = ({ width, height }: { width: number; height: number }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 313.23315 216.02286"
      version="1.1"
      id="svg5"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>YouTube Logo</title>
      <defs id="defs2" />
      <g id="layer1" transform="translate(-54.079375,-5.2758072)">
        <path
          d="m 210.53177,221.29866 c 0,0 98.12514,0 122.46443,-6.48069 13.70449,-3.6724 24.01093,-14.2575 27.62825,-27.32688 6.68807,-23.97854 6.68807,-74.41988 6.68807,-74.41988 0,0 0,-50.117297 -6.68807,-73.879819 C 357.00713,25.79798 346.70069,15.42887 332.9962,11.864515 308.65691,5.2758072 210.53177,5.2758072 210.53177,5.2758072 c 0,0 -97.9062,0 -122.135976,6.5887078 -13.485335,3.564355 -24.010529,13.933465 -27.847831,27.326876 -6.468588,23.762522 -6.468588,73.879819 -6.468588,73.879819 0,0 0,50.44134 6.468588,74.41988 3.837302,13.06938 14.362496,23.65448 27.847831,27.32688 24.229776,6.48069 122.135976,6.48069 122.135976,6.48069 z"
          fill="#ff0033"
          id="path1412"
          style={{ strokeWidth: 0.0208149 }}
          clipPath="none"
        />
        <path
          d="M 259.30109,113.28723 178.29251,67.382379 v 91.809711 z"
          fill="#ffffff"
          id="path1414"
          style={{ strokeWidth: 0.0208149 }}
          clipPath="none"
        />
      </g>
    </svg>
  );
};
